import EventActionProto from '../event-action-proto'
import SessionLoader from '../../../core/gd/data/session-loader'
import {TemplateModelSession} from "../../gd-model/project-template/template-model-session"
import {SESSION_PROJECTS_CHANGED} from "../../gd/bus/bus-event-type"
import ProjectSession from "../../model2/project/project-session"

const debug = false
// const debug = "EventProjectsNew"

export default class EventProjectsNew extends EventActionProto {

    constructor(sessionEvent) {

        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)

        // this.data : [{project}]

        this.method     = sessionEvent.method
        this.header     = {
            // projects    : sessionEvent.projects,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        debug && console.log(debug, 'process', this.data, this)

        let templates         = []
        let projectsToAdd     = []
        let allStatuses         = []

        // collect data for all templates/projects
        _.map(this.data, rawProject=>{
            if (rawProject.isTemplate && !rawProject.parentId) {
                const newTemplateModel = new ProjectSession(rawProject)
                templates.push(newTemplateModel)
            }

            projectsToAdd.push(new ProjectSession(rawProject))

            if (rawProject.taskStatusesOverride) {
                allStatuses = allStatuses.concat(rawProject.taskStatusesOverride)
            }
        })
        templates       = _.uniqBy(templates, t=>t.id)
        projectsToAdd   = _.uniqBy(projectsToAdd, p=>p.id)

        debug && console.log(debug, 'process gd.session', templates, projectsToAdd)

        // add all templates/projects to session at once
        // leave only templates not already present in gd.session.templatesList
        const newTemplates = _.filter(templates, t=>!gd.session.templatesList.get(t.id))
        gd.session.templatesList.addMany(newTemplates)
        // leave only projects not already present in gd.session.projects
        const newProjectsToAdd = _.filter(projectsToAdd, p=>!gd.session.projects.get(p.id))
        gd.session.projects.addMany(newProjectsToAdd)

        _.map(newProjectsToAdd, project=>project.initTree())

        // gd.session.projects.trigger('reset')

        debug && console.log(debug, 'process findMissing', _.uniq(allStatuses))

        // find all missing statuses with one request
        let sessionLoader = new SessionLoader()
        sessionLoader.process(gd.session.findMissing({
            statuses: _.uniq(allStatuses)
        }))

        sessionLoader.done(()=>{
            debug && console.log(debug, 'process gd.modelBus.newUpdate')
            // fire model bus events for each template/project
            _.map(this.data, (rawProject, key)=>{
                const header = {
                    // project     : this.header.projects[key],
                    project     : {
                        id          : rawProject.id,
                        parentId    : rawProject.parentId
                    },
                    isBulkUpdate: this.header.isBulkUpdate || this.data?.length>1
                }
                gd.modelBus.newUpdate('project', this.method, rawProject.id, rawProject, header)
            })

            gd.bus.triggerEvent(SESSION_PROJECTS_CHANGED)

        })

        debug && console.log(debug, 'process resetCompanyProjects')

        // reset company tree including new projects
        if (projectsToAdd.length > 0 && gd.tree) { // there is a chance when there is no tree when new user creates new company (!) so we skip it in here!
            gd.tree.resetCompanyProjects(this.companyId)
        }
    }
};